goog.module('yext.storm.GoogleMapWrapper');
goog.module.declareLegacyNamespace();

/**
 * Creates a google.maps.Map and displays it in the element with ID = parentId.
 *
 * @constructor
 * @param {number} latitude       The latitude value for the center of the map
 * @param {number} longitude      The longitude value for the center of the map
 * @param {string} parentId       The id of the DOM element to contain the map
 */
const GoogleMapWrapper = function(latitude, longitude, parentId) {
  // google.maps.LatLng representing the original center of the map
  this.center_ = new google.maps.LatLng(latitude, longitude);
  // Zoom value to start at when viewing the map
  this.zoom_ = 17;

  var mapOptions = {
    center: this.center_,
    zoom: this.zoom_,
    mapTypeId: google.maps.MapTypeId.HYBRID,
    zoomControl: true,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.LARGE,
      position: google.maps.ControlPosition.RIGHT_CENTER,
    },
    panControl: true,
    panControlOptions: {
      position: google.maps.ControlPosition.TOP_LEFT,
    },
    scaleControl: true,
    streetViewControl: false,
    mapTypeControl: true,
    scrollwheel: true,
  };

  // google.maps.Map for displaying customer location
  this.map_ = new google.maps.Map(document.getElementById(parentId), mapOptions);
};
goog.exportSymbol('GMapWrapper', GoogleMapWrapper);

/**
 * Creates a map marker.
 *
 * @param {number} latitude   The latitude
 * @param {number} longitude  The longitude
 * @param {string} iconUrl    A url to the icon to use for the marker
 * @return {!Object}           A handle to the marker object
 */
GoogleMapWrapper.prototype.createMarker = function(latitude, longitude, iconUrl) {
  return new google.maps.Marker({
    map: this.map_,
    position: new google.maps.LatLng(latitude, longitude),
    icon: iconUrl,
    draggable: true,
  });
};

/**
 * Moves a map marker to a new location.
 *
 * @param {!Object} marker     A marker object, previously returned by createMarker
 * @param {number} latitude   The new latitude for the marker
 * @param {number} longitude  The new longitude for the marker
 * @return {GoogleMapWrapper}      A reference to this object
 */
GoogleMapWrapper.prototype.moveMarker = function(marker, latitude, longitude) {
  marker.setPosition({lat: latitude, lng: longitude});
  return this;
};

/**
 * Sets the visibility of a map marker.
 *
 * @param {!Object} marker     A marker object, previously returned by createMarker
 * @param {boolean} visible   Whether or not the marker should be visible
 * @return {GoogleMapWrapper}      A reference to this object
 */
GoogleMapWrapper.prototype.setMarkerVisible = function(marker, visible) {
  marker.setVisible(visible);
  return this;
};

/**
 * Binds a function to be called when a map marker is dragged.
 *
 * @param {!Object} marker                 A marker object, previously returned by createMarker
 * @param {function(number, number)} fn   The callback function, which receives (lat, lng) of the
 *                                        new marker location
 * @return {GoogleMapWrapper}                  A reference to this object
 */
GoogleMapWrapper.prototype.markerDragged = function(marker, fn) {
  google.maps.event.addListener(marker, 'dragend', function(e) {
    fn(e.latLng.lat(), e.latLng.lng());
  });
  return this;
};

/**
 * Sets the center of the map.
 *
 * @param {number} latitude   The latitude of the map center point
 * @param {number} longitude  The longitude of the map center point
 * @return {GoogleMapWrapper}      A reference to this object
 */
GoogleMapWrapper.prototype.setCenter = function(latitude, longitude) {
  this.map_.setCenter({lat: latitude, lng: longitude});
  return this;
};

/**
 * Resets the zoom level of the map to its default value.
 *
 * @return {GoogleMapWrapper}  A reference to this object
 */
GoogleMapWrapper.prototype.resetZoom = function() {
  this.map_.setZoom(this.zoom_);
  return this;
};

/**
 * Resizes the map to fill its parent element. Must be called whenever the parent's size changes.
 *
 * @return {GoogleMapWrapper}  A reference to this object
 */
GoogleMapWrapper.prototype.resize = function() {
  google.maps.event.trigger(this.map_, 'resize');
  return this;
};

exports = GoogleMapWrapper;
